import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  asset_type: {
    name: 'Asset type',
    isStatic: false
  },
  position_type: {
    name: 'Position type',
    isStatic: false
  },
  market_code_type: {
    name: 'Market code type',
    isStatic: false
  },
  market_code: {
    name: 'Market code',
    isStatic: false
  },
  aggregated_value_amount: {
    name: 'Asset aggregated value',
    isStatic: false
  },
  aggregated_value_rate: {
    name: 'Asset aggregated value percentage',
    isStatic: false
  },
  source_name: {
    name: 'Counterparty name',
    isStatic: false
  },
  source_lei: {
    name: 'Counterparty LEI',
    isStatic: false
  },
  source_bic: {
    name: 'Counterparty BIC',
    isStatic: false
  }
  // market: {
  //   name: 'Market',
  //   isStatic: true,
  //   description: '',
  // },

  // counterparty: {
  //   name: 'Counterparty (if there is one)',
  //   isStatic: true,
  //   description: '',
  // },
};

export function MostImportPortfolio({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    columns: columns,
    onChange: onChange,
    tables
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.MOST_IMPORTANT_PORTFOLIO,
    onChangeFund,
    schema: schema.MOST_IMPORTANT_PORTFOLIO,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.MOST_IMPORTANT_PORTFOLIO?.field_names || [],
    tableName: 'MOST_IMPORTANT_PORTFOLIO',
    order: 103,
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="reporttables-most-important-portfolio-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'MOST_IMPORTANT_PORTFOLIO'}
          id={`reporttables-most-important-portfolio-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
